import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import '../../../css/SubscriptionFee/PremiumSubscriptionPlan.css';
import dot from '../../../Assets/ContainerStatus/Assets_Desktop/indicator-dot.svg';
import { successManageProfile } from "../../../Redux/_actions/manageProfile.action";
import { connect } from 'react-redux';
import { store } from '../../../Redux/_helpers/store';
import { baseURL } from '../../../Services/config/apiGateway';
import { SUBSCRIPTION_PAYMENT_ENDPOINT, SUBSCRIPTION_PLANS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { ApiCall } from '../../../Services/utils/ApiCall';
import SuccessModal from '../../Shared/SuccessModal';
import { AES, enc } from 'crypto-js';

class paymentProcess extends Component {
    constructor(props) {
        super(props)
        this.state = {
            planData: {},
            hasOpenSuccess: false,
            paymentReferenceNum: '',
        }
    }
    // apiCall for all base plans
    getBasePlansApi = (planIdValue) => {
        ApiCall(
            'GET',
            baseURL + SUBSCRIPTION_PLANS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("in 500");
                }
                else {
                    console.log('I am 200!');
                    console.log('data---', data, planIdValue)
                    let filteredData = data?.filter(item => item.planId == planIdValue);
                    console.log("FormatedData", filteredData)
                    if (filteredData) {
                        this.setState({ planData: filteredData[0] });
                    }
                }
            }
        });
    }
    componentDidMount() {
        const { planIdValue } = this.props.match.params;
        if (this.props.history.location.state) {
            this.setState({ planData: this.props.history.location.state });
        } else {
            this.getBasePlansApi(planIdValue);
        }
    }
    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
        let rolesData1 = this.props.userProfileDataR?.profileRoles.filter(role => !["Preview", "preview"].includes(role.roleType));
        rolesData1?.every((md, index) => {
            if (['Approved', 'approved'].includes(md.profileStatus)) {
                console.log('mdPremium', md, index);
                const data = {
                    selectedProfile: index,
                    selectedProfileType: md.roleType,
                    selectedProfileStatus: md.profileStatus,
                    selectedProfileRoleName: md.roleName
                }
                store.dispatch(successManageProfile(data));
                return false
            }
            return true
        })
        this.props.history.push('/home', {});
    };
    onPayment = () => {
        ApiCall(
            'POST',
            baseURL + SUBSCRIPTION_PAYMENT_ENDPOINT,
            //  "http://102.133.203.194:8084/tpt/cargoconnect/serviceorder/v1/subscribe/payment",
            {
                "amount": this.state.planData?.amount,
                "orderDate": Math.round(new Date().getTime()),
                "paymentMethod": "string",
                "paymentReference": 0,
                "planId": this.state.planData?.planId,
                "tax": this.state.planData?.tax,
                "tenure": this.state.planData?.tenure,
                "totalAmount": this.state.planData?.totalAmount,
                "invoicePDF": "string"
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        )
            .then((data) => {
                console.log('functions', data);
                if (data.flag != -1) {
                    if (data.flag == 500) {
                        console.log('In 500!');
                    }
                    else {
                        console.log('In 200!');
                        console.log('payment--', data);
                        this.setState({
                            paymentReferenceNum: data?.transactionId,
                            hasOpenSuccess: true
                        });
                    }
                }
                else {
                    console.log('some error');
                }
            })
    }
    getDate(planValidity) {
        if (planValidity) {
            let rawDate = planValidity.split("/");
            let processedDate = new Date(rawDate[2], rawDate[1] - 1, rawDate[0]).toString();
            let date = new Date(processedDate).toString();
            let day = date.split(' ')[2];
            let month = date.split(' ')[1];
            let year = date.split(' ')[3];
            return `${day}-${month}-${year}`;
        }
        return planValidity
    }
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.premiumSubscriptionPlanPageTitle} description={TitleDescription.premiumSubscriptionPlanPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="pscsnofull">
                    <div id="pscsnobox1">
                        <nav class="rnononavbar">
                            <div className="rnonavbarname">
                                <small id="nonavc">Select Payment Method</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="managementmaincard">
                            <div>
                                <div class="mscarddiv2">
                                    <div class="pspsubhisdiv">
                                        <small class="mscarddivsm1">{this.state.planData?.tenure} Premium Subscription Plan</small>
                                    </div>
                                    <div>
                                        <div class="pspmscardactive1">
                                            <div class="pspdivout1">
                                                <div class="psupmargin">
                                                    <small>
                                                        <small class="pspdivsmr">R </small>
                                                        <small class="pspdivsmin"> {this.state.planData?.totalAmount}</small>
                                                    </small>
                                                </div>
                                                <small class="pspdivsm2">Valid till {this.getDate(this.state.planData?.toDate)}</small>
                                            </div>
                                            <div class="pspdivout2">
                                                <img src={dot} id="" class=" mr-2" alt="" loading="lazy" />
                                                <small class="pspdivsm3">This amount is non-refundable</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pspsmscarddiv3">
                                    <div class="mscarddivbuttout">
                                        <Button class="mscarddivbutt" onClick={this.onPayment}>Proceed To Pay</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="psnotifooter01">
                    <Footer />
                </div>
                <div class="psnotifooter02">
                    <Footer2 />
                </div>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">Payment successful</small>
                            <small class="successRatingdivsm">Transaction Id. {this.state.paymentReferenceNum}</small>
                        </div>
                    </div>
                </SuccessModal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            manageProfileDataR: state.manageProfileReducer.data,
            userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
        }
    }
}
export default connect(mapStateToProps)(paymentProcess);